import React from 'react'

function DefaultMaskIcon() {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M31.9999 57.6005C47.3162 57.6005 59.7333 45.2078 59.7333 29.8671C59.7333 14.5264 47.2615 2.13379 31.9999 2.13379C16.6837 2.13379 4.2666 14.5264 4.2666 29.8671C4.2666 45.2078 16.6837 57.6005 31.9999 57.6005Z"
                fill="#F6F6F6"
                stroke="#C3C3C3"
                strokeMiterlimit="10"
            />
            <path
                d="M47.5898 48.5495H55.505C56.4992 48.5495 57.3513 47.6978 57.3513 46.7041V9.79655C57.3513 8.80289 56.4992 7.95117 55.505 7.95117H47.8356"
                fill="#EEEEEE"
            />
            <path
                d="M47.5898 48.5495H55.505C56.4992 48.5495 57.3513 47.6978 57.3513 46.7041V9.79655C57.3513 8.80289 56.4992 7.95117 55.505 7.95117H47.8356L47.5898 48.5495Z"
                stroke="#C3C3C3"
                strokeMiterlimit="10"
            />
            <path
                d="M16.1641 48.5495H8.49477C7.50059 48.5495 6.64844 47.6978 6.64844 46.7041V9.79655C6.64844 8.80289 7.50059 7.95117 8.49477 7.95117H16.0062"
                fill="#EEEEEE"
            />
            <path
                d="M16.1641 48.5495H8.49477C7.50059 48.5495 6.64844 47.6978 6.64844 46.7041V9.79655C6.64844 8.80289 7.50059 7.95117 8.49477 7.95117H16.0062L16.1641 48.5495Z"
                stroke="#C3C3C3"
                strokeMiterlimit="10"
            />
            <path d="M11.9839 15.333H15.8186" stroke="#C3C3C3" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M11.9839 20.3008H15.8186" stroke="#C3C3C3" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M11.9839 25.4111H15.8186" stroke="#C3C3C3" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M11.9839 30.5215H15.8186" stroke="#C3C3C3" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M11.9839 40.458H15.8186" stroke="#C3C3C3" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M51.5286 15.333H47.8359" stroke="#C3C3C3" strokeMiterlimit="10" />
            <path d="M51.5286 20.3008H47.8359" stroke="#C3C3C3" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M51.5286 25.4111H47.8359" stroke="#C3C3C3" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M51.5286 30.5215H47.8359" stroke="#C3C3C3" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M51.5286 40.458H47.8359" stroke="#C3C3C3" strokeMiterlimit="10" strokeLinecap="round" />
            <path
                d="M45.9893 51.6726H17.8683C16.8741 51.6726 16.022 50.8209 16.022 49.8273V6.95768C16.022 5.96402 16.8741 5.1123 17.8683 5.1123H45.9893C46.9835 5.1123 47.8357 5.96402 47.8357 6.95768V49.8273C47.8357 50.8209 46.9835 51.6726 45.9893 51.6726Z"
                fill="white"
                stroke="#C9C9C9"
                strokeMiterlimit="10"
            />
            <path
                d="M42.5806 19.0015H22.9811C22.555 19.0015 22.271 18.7442 22.271 18.3583V16.6861C22.271 16.3002 22.555 16.043 22.9811 16.043H42.5806C43.0067 16.043 43.2908 16.3002 43.2908 16.6861V18.3583C43.2908 18.6156 43.0067 19.0015 42.5806 19.0015Z"
                fill="#EEEEEE"
                stroke="#C3C3C3"
                strokeMiterlimit="10"
            />
            <path
                d="M42.5806 26.6665H22.9811C22.555 26.6665 22.271 26.4093 22.271 26.0234V24.3512C22.271 23.9653 22.555 23.708 22.9811 23.708H42.5806C43.0067 23.708 43.2908 23.9653 43.2908 24.3512V26.0234C43.2908 26.4093 43.0067 26.6665 42.5806 26.6665Z"
                fill="#EEEEEE"
                stroke="#C3C3C3"
                strokeMiterlimit="10"
            />
            <path
                d="M42.5806 34.4741H22.9811C22.555 34.4741 22.271 34.2169 22.271 33.831V32.1588C22.271 31.7729 22.555 31.5156 22.9811 31.5156H42.5806C43.0067 31.5156 43.2908 31.7729 43.2908 32.1588V33.831C43.2908 34.2169 43.0067 34.4741 42.5806 34.4741Z"
                fill="#EEEEEE"
                stroke="#C3C3C3"
                strokeMiterlimit="10"
            />
            <path
                d="M42.5811 42.4234H34.7697C34.3436 42.4234 34.0596 42.1661 34.0596 41.7802V40.108C34.0596 39.7221 34.3436 39.4648 34.7697 39.4648H42.5811C43.0072 39.4648 43.2912 39.7221 43.2912 40.108V41.7802C43.2912 42.1661 43.0072 42.4234 42.5811 42.4234Z"
                fill="#EEEEEE"
                stroke="#C3C3C3"
                strokeMiterlimit="10"
            />
            <path
                d="M41.9277 53.7995C41.721 54.6767 41.4109 55.6055 41.049 56.3795C40.0669 58.2888 38.5163 59.7852 36.6038 60.7656C34.6396 61.746 32.3136 62.1588 29.9877 61.6428C24.457 60.456 20.9421 55.1411 22.0793 49.6714C23.2164 44.2017 28.5404 40.6412 34.0194 41.828C35.9835 42.2408 37.6893 43.2212 39.1365 44.5629C41.6176 46.9881 42.5997 50.4454 41.9277 53.7995Z"
                fill="#C3C3C3"
                stroke="#959595"
                strokeMiterlimit="10"
            />
            <path
                d="M31.9995 47.1572C32.8107 47.1572 33.3783 47.8124 33.3784 48.5342V50.3564H35.2046C35.9256 50.3564 36.5833 50.9216 36.5835 51.7334C36.5835 52.5454 35.9257 53.1113 35.2046 53.1113H33.3784V54.9326C33.3784 55.7446 32.7206 56.3105 31.9995 56.3105C31.1884 56.3103 30.6216 55.6544 30.6216 54.9326V53.1113H28.7954C28.4175 53.1113 28.0667 52.9768 27.8091 52.7197C27.5514 52.4625 27.4165 52.1114 27.4165 51.7334C27.4167 50.9216 28.0744 50.3564 28.7954 50.3564H30.6216V48.5342C30.6217 47.7225 31.2787 47.1574 31.9995 47.1572Z"
                fill="white"
                stroke="#959595"
            />
        </svg>
    )
}

export default DefaultMaskIcon
